import { Image, Text, View } from '@react-pdf/renderer';
import React, { FC } from 'react';
import { IntlFormatters } from '@formatjs/intl/src/types';

import { getAge, getLocation, getName, getTitleProfile } from '../utils/generateDataForDocx';
import { styles } from './styles';

type ResumePdfHeaderProps = {
  formatDate: IntlFormatters['formatDate'];
  formatMessage: IntlFormatters['formatMessage'];
  profile: AH$Profile;
};

export const ResumePdfHeader: FC<ResumePdfHeaderProps> = ({
  profile,
  formatMessage,
  formatDate,
}) => {
  const isValidAge = profile?.age && profile.age > 0;

  return (
    <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
      <View>
        <View style={{ flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center' }}>
          <Text style={styles.heading}>{getName(profile)}</Text>
          <Text style={styles.subheading}>
            {isValidAge ? `, ${getAge({ profile, formatDate, formatMessage })}` : ''}
          </Text>
        </View>
        <Text style={styles.subheading}>{getTitleProfile(profile)}</Text>
        <Text style={styles.subheading}>{getLocation(profile)}</Text>
      </View>
      {profile.photo ? <Image style={styles.image} src={`${profile.photo}`} /> : null}
    </View>
  );
};
